import { SET_PROVIDERS } from '~/store/feature/Provider';
import { api } from '../api';
import { PROVIDERS_PATH } from '../endpoints';
import { GlobalResponse, ProviderItem } from '~/models/Comons';

const extendedApiSlice = api.injectEndpoints({
    endpoints: builder => ({
        getProviders: builder.query<GlobalResponse<ProviderItem[]>, void>({
            query: () => ({
                url: PROVIDERS_PATH,
                method: 'GET',
                credentials: 'include',
                headers: {
                    Authorization: sessionStorage.getItem('access_token') ? `Bearer ${sessionStorage.getItem('access_token')}` : ``,
                }
            }),
            async onQueryStarted(_, { dispatch, queryFulfilled }) {
                const { data } = await queryFulfilled;
                dispatch(SET_PROVIDERS(data.payload));
            },
        }),
    }),
});

export const { useGetProvidersQuery } = extendedApiSlice;

